const routerDE = {
    "releases": {
        "view": {
            "name": "Veröffentlichungen",
            "buttonText": "Neue Veröffentlichung hinzufügen",
            "secondaryButtonText": "Veröffentlichung übertragen",
            "headerText": "Veröffentlichungen"
        },
        "add": {
            "name": "Neue Veröffentlichung hinzufügen",
            "headerText": "Veröffentlichungen"
        },
        "update": {
            "name": "Veröffentlichung aktualisieren",
            "headerText": "Veröffentlichungen"
        },
        "details": {
            "name": "Veröffentlichungsdetails",
            "headerText": "Veröffentlichungen"
        },
        "transfer": {
            "name": "Veröffentlichung übertragen",
            "headerText": "Veröffentlichungen"
        },
        "tracks": {
            "name": "Titelliste",
            "headerText": "Veröffentlichungen"
        },
        "deliveryConfirmation": {
            "name": "Gelieferte Liste",
            "headerText": "Gelieferte Liste"
        },
        "storeDeliveryList": {
            "name": "Store-Lieferliste",
            "headerText": "Store-Lieferliste"
        }
    },
    "copyrightInfringements": {
        "view": {
            "name": "Urheberrechtsverletzungen",
            "headerText": "Urheberrechtsverletzungen"
        }
    },
    "escrowWallet": {
        "view": {
            "name": "Treuhand-Wallet",
            "headerText": "Treuhand-Wallet"
        }
    },
    "artists": {
        "view": {
            "name": "Künstler",
            "buttonText": "Neuen Künstler hinzufügen",
            "headerText": "Künstler"
        },
        "add": {
            "name": "Neuen Künstler hinzufügen",
            "headerText": "Künstler"
        },
        "update": {
            "name": "Künstler aktualisieren",
            "headerText": "Künstler"
        },
        "viewDetails": {
            "name": "Künstlerdetails anzeigen",
            "headerText": "Künstlerdetails anzeigen"
        },
        "wishlist": {
            "name": "Künstler-Wunschliste",
            "headerText": "Künstler-Wunschliste"
        },
        "addFromWishlist": {
            "name": "Künstler aus Wunschliste hinzufügen",
            "headerText": "Künstler aus Wunschliste hinzufügen"
        }
    },
    "trends": {
        "view": {
            "name": "Trends",
            "headerText": "Trends"
        }
    },
    "earningsDrilldown": {
        "view": {
            "name": "Einnahmen",
            "headerText": "Einnahmen-Drilldown"
        }
    },
    "accounting": {
        "view": {
            "name": "Smart Accounting",
            "headerText": "Smart Accounting",
            "buttonText": "Neue Buchhaltung hinzufügen"
        },
        "add": {
            "name": "Neue Buchhaltung hinzufügen",
            "headerText": "Neue Buchhaltung hinzufügen"
        },
        "breakdown": {
            "name": "Buchhaltungsaufschlüsselung",
            "headerText": "Buchhaltungsaufschlüsselung"
        }
    },
    "invoices": {
        "view": {
            "name": "Rechnungen",
            "headerText": "Rechnungen",
            "buttonText": "Rechnung hinzufügen"
        },
        "add": {
            "name": "Rechnung hinzufügen",
            "headerText": "Rechnung hinzufügen"
        }
    },
    "musicLink": {
        "view": {
            "name": "Musiklink",
            "buttonText": "Neuen Musiklink hinzufügen",
            "headerText": "Musiklink",
            "secondaryButtonText": "Musiklink-URL"
        },
        "add": {
            "name": "Musiklink hinzufügen",
            "headerText": "Musiklink"
        },
        "update": {
            "name": "Musiklink aktualisieren",
            "headerText": "Musiklink"
        },
        "viewStats": {
            "name": "Musiklink-Ansichtsstatistiken",
            "headerText": "Musiklink-Ansichtsstatistiken"
        }
    },
    "musicLinkUrlpart": {
        "view": {
            "name": "Musiklink-URL-Teil",
            "buttonText": "Neuen Musiklink-URL-Teil hinzufügen",
            "headerText": "Musiklink-URL-Teil"
        },
        "add": {
            "name": "Neuen Musiklink-URL-Teil hinzufügen",
            "headerText": "Musiklink-URL-Teil"
        },
        "update": {
            "name": "Musiklink-URL-Teil aktualisieren",
            "headerText": "Musiklink-URL-Teil"
        }
    },
    "linkLandingPage": {
        "view": {
            "name": "Link-Landingpage",
            "buttonText": "Link-Landingpage hinzufügen",
            "headerText": "Link-Landingpage"
        },
        "add": {
            "name": "Link-Landingpage hinzufügen",
            "headerText": "Link-Landingpage"
        },
        "update": {
            "name": "Link-Landingpage aktualisieren",
            "headerText": "Link-Landingpage"
        },
        "viewAnalytics": {
            "name": "Link-Landingpage-Analysen",
            "headerText": "Link-Landingpage"
        }
    },
    "mastering": {
        "view": {
            "name": "Mastering",
            "buttonText": "Mastering hinzufügen",
            "headerText": "Audio-Mastering"
        },
        "add": {
            "name": "Mastering hinzufügen",
            "headerText": "Audio-Mastering"
        },
        "update": {
            "name": "Mastering aktualisieren",
            "headerText": "Audio-Mastering"
        },
        "viewSongs": {
            "name": "Audio-Mastering-Songs",
            "headerText": "Audio-Mastering-Songs"
        }
    },
    "featureRequest": {
        "view": {
            "name": "Funktionsanfrage",
            "buttonText": "Neue Funktionsanfrage",
            "headerText": "Funktionsanfrage"
        },
        "add": {
            "name": "Funktionsanfrage hinzufügen",
            "headerText": "Funktionsanfrage"
        }
    },
    "scWhitelist": {
        "view": {
            "name": "SC-Whitelist",
            "headerText": "SC-Whitelist"
        }
    },
    "profile": {
        "view": {
            "name": "Profil",
            "headerText": "Mein Profil"
        }
    },
    "announcements": {
        "view": {
            "name": "Ankündigungen",
            "headerText": "Ankündigungen"
        }
    },
    "twoFactorAuthentication": {
        "view": {
            "name": "Zwei-Faktor-Authentifizierung",
            "headerText": "Zwei-Faktor-Authentifizierung"
        }
    },
    "completeYourInformation": {
        "view": {
            "name": "Vervollständigen Sie Ihre Informationen",
            "headerText": "Vervollständigen Sie Ihre Informationen"
        }
    },
    "tokens": {
        "view": {
            "name": "Tokens",
            "headerText": "Tokens"
        }
    },
    "orderTokens": {
        "view": {
            "name": "Tokens bestellen",
            "headerText": "Tokens bestellen"
        }
    },
    "accessKeys": {
        "view": {
            "name": "Zugangsschlüssel",
            "headerText": "Zugangsschlüssel"
        }
    },
    "paymentMethods": {
        "view": {
            "name": "Zahlungsmethoden",
            "buttonText": "Zahlungsmethode hinzufügen",
            "headerText": "Meine Zahlungsmethoden"
        },
        "add": {
            "name": "Zahlungsmethode hinzufügen",
            "headerText": "Meine Zahlungsmethoden"
        },
        "update": {
            "name": "Zahlungsmethode aktualisieren",
            "headerText": "Meine Zahlungsmethoden"
        }
    },
    "orderCredits": {
        "view": {
            "name": "Bestellguthaben",
            "headerText": "Bestellguthaben"
        }
    },
    "purchaseHistory": {
        "view": {
            "name": "Kaufhistorie",
            "headerText": "Kaufhistorie"
        }
    },
    "subscription": {
        "view": {
            "name": "Mein Abonnement",
            "headerText": "Mein Abonnement"
        },
        "upgrade": {
            "name": "Abonnement upgraden",
            "headerText": "Abonnement upgraden"
        }
    },
    "subUsers": {
        "view": {
            "name": "Unterbenutzer",
            "buttonText": "Neuen Unterbenutzer hinzufügen",
            "headerText": "Meine Unterbenutzer"
        },
        "add": {
            "name": "Neuen Unterbenutzer hinzufügen",
            "headerText": "Meine Unterbenutzer"
        },
        "edit": {
            "name": "Unterbenutzer bearbeiten",
            "headerText": "Meine Unterbenutzer"
        }
    },
    "labels": {
        "view": {
            "name": "Labels",
            "buttonText": "Neues Label hinzufügen",
            "headerText": "Meine Labels"
        },
        "add": {
            "name": "Neues Label hinzufügen",
            "headerText": "Meine Labels"
        },
        "edit": {
            "name": "Label bearbeiten",
            "headerText": "Meine Labels"
        }
    },
    "statements": {
        "view": {
            "name": "Abrechnungen",
            "headerText": "Finanzberichte"
        }
    },
    "subuserStatements": {
        "viewParentUser": {
            "name": "Unterbenutzer-Abrechnungen",
            "headerText": "Unterbenutzer-Abrechnungen"
        },
        "viewSubuser": {
            "name": "Benutzerabrechnungen",
            "headerText": "Benutzerabrechnungen"
        }
    },
    "dashboard": {
        "view": {
            "name": "Startseite",
            "headerText": "Startseite"
        }
    }
};

export default routerDE;